var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9991 2.60541C23.9 3.40038 23.4109 3.95323 22.8635 4.49433C18.8178 8.49124 14.782 12.498 10.7487 16.5067C10.1785 17.0732 9.51403 17.3628 8.70593 17.2918C8.19454 17.2471 7.73907 17.0586 7.35232 16.7173C7.29402 16.6656 7.23667 16.6129 7.18169 16.5584C5.04368 14.4386 2.90472 12.3198 0.76955 10.1973C-0.0793042 9.35343 -0.238553 8.16874 0.354839 7.2003C1.11175 5.96485 2.85732 5.69077 3.9569 6.63946C4.16876 6.82233 4.36308 7.02495 4.56214 7.22193C5.95462 8.60171 7.34663 9.98244 8.73722 11.3646C8.79741 11.4247 8.84196 11.5 8.89409 11.5686C8.92869 11.5799 8.96282 11.5912 8.99742 11.6024C9.04529 11.5216 9.07894 11.4262 9.14387 11.3622C12.6928 7.83684 16.2466 4.31663 19.7936 0.789364C20.3444 0.241682 20.9861 -0.0427368 21.7681 0.00521477C22.88 0.0733813 23.7844 0.89373 23.9602 1.98768C23.9687 2.03987 23.9867 2.09064 24 2.14188C23.9991 2.29514 23.9991 2.45028 23.9991 2.60541Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.9c4553ea3d63ff5c3e590e1170838d90.svg";
export { ForwardRef as ReactComponent };